import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiClient } from "../../../../zodios/client";

interface WalmartAdvertisingSetupParams {
  advertiserId: string;
  /** Update the ID already stored for this org rather than onboarding a new one. */
  reauth?: boolean;
  /** Save even though Walmart has not confirmed access, on the user's assurance. */
  force?: boolean;
}

export const useWalmartAdvertisingSetup = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ advertiserId, reauth, force }: WalmartAdvertisingSetupParams) => {
      if (reauth) {
        return await apiClient.updateWalmartAdvertiserId({ advertiser_id: advertiserId, force });
      }
      return await apiClient.submitWalmartAdvertiserId({ advertiser_id: advertiserId, force });
    },
    onSettled: () => {
      void queryClient.invalidateQueries({ queryKey: ["walmart-onboarding-status"] });
    },
  });
};
